export default __webpack_public_path__ + "static/media/github.746ec8f0.png";